import { SynchronizePaymentTradesApi } from "@/features/accounts/payment/scraping/services/synchronize-trades-api";
import { SynchronizePaymentTradesPostRequestModel } from "@/features/accounts/payment/scraping/services/synchronize-trades-model";

/// Look明細同期処理
export class SynchronizePaymentTradesService {
  private synchronizePaymentTradesApi = new SynchronizePaymentTradesApi();

  /**
   * Look明細同期API実行
   */
  public async synchronizePaymentTrades(param: SynchronizePaymentTradesPostRequestModel) {
    return await this.synchronizePaymentTradesApi.synchronizePaymentTrades(param);
  }
}
